import { render, staticRenderFns } from "./VariablePrice.vue?vue&type=template&id=5466dc5d&"
import script from "./VariablePrice.vue?vue&type=script&lang=js&"
export * from "./VariablePrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports